import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import Accordion from "react-bootstrap/Accordion";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { useParams } from "react-router-dom";
import IsLoading from "../../components/Loading/IsLoading";
import {
  instructorApi,
  useGetCourseDetailQuery,
} from "../../api/instructorApi";
import {
  useDownloadMaterialFileMutation,
  useRemoveMaterialAsyncMutation,
  useUploadMaterialFileMutation,
} from "../../api/materialApi";
import JSZip from "jszip";
import {
  useAddVideoAsyncMutation,
  useChangeVideoAsncMutation,
  useGetWatchVideoUrlMutation,
  useRemoveVideoAsyncMutation,
  useUpdateVideoAsyncMutation,
  useGetUnAssignedVideosAsyncQuery,
  useUpdateAssignVideoAsyncMutation, // Add this import
} from "../../api/videoApi";
import VideoPage from "../LessonPage/VideoPage";
import { CiCircleRemove } from "react-icons/ci";
import {
  useAddSectionAsyncMutation,
  useRemoveSectionAsyncMutation,
  useUpdateSectionAsyncMutation,
  useUpdateSectionRowsMutation,
} from "../../api/sectionApi";
import { useDispatch } from "react-redux";
import CustomModal from "../CustomComponents/CustomModal";
import InstructorAuth from "../../Wrappers/HoC/InstructorAuth";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Input } from "reactstrap";
import { toast } from "react-toastify";
import { IoPencil } from "react-icons/io5";
import Spinner from "react-bootstrap/Spinner";
import { useEvaluateUpdateCourseMutation } from "../../api/courseApi";
import { courseEvaluateEnum } from "../../api/Enums/evaluateEnum";
import { useSelector } from "react-redux";
import EvaluateModal from "../CustomComponents/EvaluateModal";
import Roles from "../../Constants/Roles";
import { useTranslation } from "react-i18next";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { createContext } from "react";
import { IoRefresh } from "react-icons/io5"; // Add import for refresh icon

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxHeight: "80vh",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "12px",
  boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
  p: 4,
};
const VideoRefContext = createContext();

function InstructorsCourseDetail() {
  const videoRef = useRef();
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const buttonRef = useRef(null);
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const { slug } = useParams();
  const { data, isLoading } = useGetCourseDetailQuery(slug);
  const [downloadFile] = useDownloadMaterialFileMutation();
  const userId = useSelector((state) => state.authStore.nameIdentifier);
  const [watchingVideo] = useGetWatchVideoUrlMutation();
  const [removeVideoAsync] = useRemoveVideoAsyncMutation();
  const [removeSectionAsync] = useRemoveSectionAsyncMutation();
  const [changeVideoAsync] = useChangeVideoAsncMutation();
  const [addVideoAsync] = useAddVideoAsyncMutation();
  const [updateSectionAsync] = useUpdateSectionAsyncMutation();
  const [uploadMaterialAsync] = useUploadMaterialFileMutation();
  const [removeMaterialAsync] = useRemoveMaterialAsyncMutation();
  const [updateVideoAsync] = useUpdateVideoAsyncMutation();
  const [updateEvaluate] = useEvaluateUpdateCourseMutation();
  const [updateSectionRows] = useUpdateSectionRowsMutation();
  const [updateAssignVideoAsync] = useUpdateAssignVideoAsyncMutation(); // Add this hook
  const [title, setTitle] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [chooseVideo, setChooseVideo] = useState(false);
  const [sections, setSections] = useState([]);
  const [modal, isShowModal] = useState(false);
  const [evaluateModal, setEvaluateModal] = useState(false);
  const [createSectionAsync] = useAddSectionAsyncMutation();
  const [isEnable, setIsEnable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [handleClickedUpdateRows, setHandleClickedUpdateRows] = useState(false);
  const [editingSectionId, setEditingSectionId] = useState(null);
  const [rowNumber, setRowNumber] = useState();
  const [isContinueProocess, setIsContinueProcess] = useState(false);
  const [videoDetail, setVideoDetail] = useState({
    publicVideoId: "",
    sectionId: "",
  });
  const [sectionModel, setSectionModel] = useState({
    sectionName: "",
    description: "",
    courseId: slug,
  });
  const [userRole, setUserRole] = useState([]);

  const [evaluateModel, setEvaluateModel] = useState({
    courseId: slug,
    courseEvaluateStatus: Number,
    courseEvaluateDescription: String,
  });
  const [videoId, setVideoId] = useState(
    buttonRef.current ? buttonRef.current.dataset.value : ""
  );
  const [unassignedVideos, setUnassignedVideos] = useState([]);
  const [showUnassignedModal, setShowUnassignedModal] = useState(false);
  const [currentSectionId, setCurrentSectionId] = useState(null);
  const [unassignedVideosLoading, setUnassignedVideosLoading] = useState(false); // Add loading state
  const [unassignedVideosError, setUnassignedVideosError] = useState(null); // Add error state
  
  // Modify the query to include skip option to manually control when it runs
  const { 
    data: unassignedVideosData, 
    refetch: refetchUnassignedVideos,
    isLoading: isUnassignedVideosLoading,
    isError: isUnassignedVideosError,
    error: unassignedVideosQueryError
  } = useGetUnAssignedVideosAsyncQuery(undefined, {
    // Use polling to periodically check for new data
    pollingInterval: 30000, // Poll every 30 seconds
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
  
  // New state for video assignment
  const [assigningVideo, setAssigningVideo] = useState(false);
  const [selectedRowNumber, setSelectedRowNumber] = useState(1);
  const [videoTitle, setVideoTitle] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // Filter unassigned videos based on search query
  const filteredUnassignedVideos = useMemo(() => {
    if (!unassignedVideosData) return [];
    
    return unassignedVideosData.filter((video) => 
      video.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [unassignedVideosData, searchQuery]);

  // Enhanced function to fetch unassigned videos with better error handling
  const fetchUnassignedVideos = useCallback(async () => {
    try {
      setUnassignedVideosLoading(true);
      setUnassignedVideosError(null);
      await refetchUnassignedVideos();
    } catch (error) {
      console.error("Error fetching unassigned videos:", error);
      setUnassignedVideosError(error.message || "Failed to load videos");
      toast.error(t("Failed to load unassigned videos. Please try again."));
    } finally {
      setUnassignedVideosLoading(false);
    }
  }, [refetchUnassignedVideos, t]);

  // Fetch unassigned videos when component mounts and when modal is opened
  useEffect(() => {
    if (showUnassignedModal) {
      fetchUnassignedVideos();
    }
  }, [showUnassignedModal, fetchUnassignedVideos]);

  // Better handling of unassigned videos data
  useEffect(() => {
    if (unassignedVideosData) {
      setUnassignedVideos(unassignedVideosData);
    } else if (isUnassignedVideosError && unassignedVideosQueryError) {
      console.error("Error in unassigned videos query:", unassignedVideosQueryError);
      toast.error(t("Failed to load videos. Please try refreshing."));
    }
  }, [unassignedVideosData, isUnassignedVideosError, unassignedVideosQueryError, t]);

  useEffect(() => {
    if (data && data.result[0] && data.result[0].sections) {
      localStorage.setItem("sections", JSON.stringify(data.result[0].sections));
      setSections(data.result[0].sections);
    }
  }, [data]);

  if (isLoading) {
    return <IsLoading />;
  }

  const handleClickWatchingVideo = async (publicVideoId) => {
    await watchingVideo(publicVideoId).then((response) => {

      if (videoRef.current && response ) {
        videoRef.current.src = response.data.result
        videoRef.current.play()

          
        }
      setChooseVideo(true);

    });
  };

  const closeVideo = () => {
    setChooseVideo(false);

  };

  const removeItem = async (itemId, itemName) => {
    var answer = window.confirm("Are you sure want to delete?");

    if (itemName === "video") {
      if (answer) {
        await removeVideoAsync(itemId).then((response) => {});
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
      }
    } else if (itemName === "section") {
      await removeSectionAsync(itemId).then((response) => {});
      dispatch(instructorApi.util.invalidateTags(["instructor"]));
    }
  };
  const handleDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const newSections = Array.from(sections);
    const [movedSection] = newSections.splice(result.source.index, 1);
    newSections.splice(result.destination.index, 0, movedSection);

    setSections(newSections);
    localStorage.setItem("sections", JSON.stringify(newSections));

    var storeSections = localStorage.getItem("sections");
    var sectionDataList = [];
    for (let index = 0; index < JSON.parse(storeSections).length; index++) {
      const element = JSON.parse(storeSections)[index];
      element.sequenceNumber = index;
      sectionDataList.push(element);
    }

    await updateSectionRows(sectionDataList).then((response) => {
      sectionDataList = [];
    });
  };

  const handleClickEdit = (sectionId) => {
    setEditingSectionId(editingSectionId === sectionId ? null : sectionId);
  };
  const handleOpenCustomModal = (title) => {
    isShowModal(!modal);
    setTitle(title);
  };

  const clickDownloadFile = async (fileUrl) => {
    var materialModel = {
      fileUrl: fileUrl,
      type: 1,
    };

    await downloadFile(materialModel).then((response) => {
      if (response.data.isSuccess) {
        const fileName = fileUrl; // Dosya ismi
    const fileExtension = fileName.split('.').pop(); // Dosya uzantısını al
    let mimeType = '';

    switch (fileExtension) {
      case 'pdf':
        mimeType = 'application/pdf';
        break;
      case 'jpg':
      case 'jpeg':
        mimeType = 'image/jpeg';
        break;
      case 'png':
        mimeType = 'image/png';
        break;
      case 'txt':
        mimeType = 'text/plain';
        break;
      case 'doc':
        mimeType = 'application/msword';
        break;
      case 'docx':
        mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      default:
        mimeType = 'application/octet-stream'; // Genel bir binary dosya tipi
        break;
    }

    // Dosya için base64 URI oluşturma
    const linkSource = `data:${mimeType};base64,${response.data.result}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
                toast.success("Download process is success completed")
      }
    });
  };

  const handleFromChildData = async (event) => {
    isShowModal(false);
    setIsContinueProcess(true);
    const formData = new FormData();
    const typeFile = event.file.target.files[0].type.split("/");
    if (
      (title == "ChangeVideo" || title == "NewVideo") &&
      typeFile[1] !== "mp4"
    ) {
      return alert("Please just mp4 format");
    }

    if (title == "ChangeVideo" || title == "NewVideo") {
      formData.append("File", event.file.target.files[0]);
      formData.append("Title", event.title);
      formData.append("RowNumberForSection", event.rowNumber);
      formData.append("SectionId", videoDetail.sectionId);
    }

    if (title == "NewMaterial") {
      formData.append("Name", event.title);
      formData.append("FileUrl", "");
      formData.append("VideoId", videoId);
      formData.append("File", event.file.target.files[0]);
    }

    const fileName = videoDetail.publicVideoId;

    if (title == "ChangeVideo") {
      await changeVideoAsync({ fileName, formData }).then((response) => {
        setLoading(true);

        if (response.data.isSuccess) {
          toast.success("Change Video Succeded");
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          setLoading(false);
          isShowModal(false);
          setIsContinueProcess(false);
        } else {
          setLoading(false);
          setIsContinueProcess(false);
        }
      });
    } else if (title == "NewMaterial") {
      await uploadMaterialAsync(formData).then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.messages[0]);
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          isShowModal(false);
          setIsContinueProcess(false);
        }
      });
    } else {
      await addVideoAsync(formData).then((response) => {
        if (response.data.isSuccess) {
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          isShowModal(false);
          toast.success(response.data.messages[0]);
          setLoading(false);
          setIsContinueProcess(false);
        } else {
          setLoading(false);
          setIsContinueProcess(false);
        }
      });
    }
  };

  const handleAuthForRoles = async (event) => {
    setUserRole(event.role);
  };

  const createSection = async () => {
    await createSectionAsync(sectionModel).then((response) => {
      if (response.data.isSuccess) {
        handleClose();
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
        toast.success("Section created succeded");
      }
    });
  };

  const handleUpdateSection = async (sectionId) => {
    const sectionUpdateModel = {
      sectionName: sectionModel.sectionName,
      description: sectionModel.description,
    };

    var selectedSection = sections.filter((x) => x.sectionId == sectionId);


    await updateSectionAsync({ sectionId, sectionUpdateModel }).then(
      (response) => {
        if (response.data.isSuccess) {
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          toast.success("Section updated");
          setIsEnable(!isEnable);
          setEditingSectionId(null);
          setSectionModel({
            sectionName: "",
            description: "",
            courseId: slug,
          });
        }
      }
    );
  };

  const handleRemoveFile = async (fileName) => {
    var answer = window.confirm("Are you sure want to delete?");

    if (answer) {
      await removeMaterialAsync(fileName).then((response) => {
        if (response.data.isSuccess) {
          toast.success("removed material");
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
        }
      });
    }
  };

  const handleSendEvaluate = async (model) => {
    if (model.returnEvaluate === undefined) {
      if (data.result[0].userId === userId) {
        //here is in the send to for evaluate instructor
        //this reason enums value is =

        dispatch(instructorApi.util.invalidateTags(["course"]));
        // setEvaluateModel({
        //   courseId:slug,
        //   courseEvaluateStatus:courseEvaluateEnum.InEvaluation,
        //   courseEvaluateDescription:"Send To Evaluate"
        // })

        const evaluationModel = {
          courseId: slug,
          CourseEvaluteStatus: courseEvaluateEnum.InEvaluation,
          courseEvaluateDescription: "Send To Evaluate",
        };

        await updateEvaluate(evaluationModel).then((response) => {
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
        });
      }
    } else {
      const evaluationModel = {
        courseId: slug,
        CourseEvaluteStatus: model.returnEvaluate.statu,
        courseEvaluateDescription: model.returnEvaluate.description,
      };

      await updateEvaluate(evaluationModel).then((response) => {
        if (response.data.isSuccess) {
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          setEvaluateModal(false);
        } else {
          toast.error("Ooops!sometihng went wrong");
        }
      });
    }
  };

  const handleClickedVideo = (videoId) => {
    if (handleClickedUpdateRows === false) {
      setSelectedVideoId(videoId);
      setHandleClickedUpdateRows(!handleClickedUpdateRows);
    } else {
      setSelectedVideoId(null);
      setHandleClickedUpdateRows(!handleClickedUpdateRows);
    }
  };

  const handleUpdateVideo = async (videoId) => {
    const updateVideoModel = {
      rowNumberForSection: rowNumber,
    };


    await updateVideoAsync({ videoId, updateVideoModel }).then((response) => {
      if (response.data.isSuccess) {
        toast.success("Video Updated Successfully");
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
        setHandleClickedUpdateRows(false);
      } else {
        toast.error(response.data.messages[0]);
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
      }
    });
  };

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: grid,
    width: `calc(100% - ${grid * 2}px)`, // padding'i hesaba katıyoruz
    boxSizing: "border-box",
  });

  const grid = 8;

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "lightblue" : "grey",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const renderButton = () => {
    if (
      data.result[0].userId === userId &&
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.Pending
    ) {
      return (
        <Button className="btn btn-danger" onClick={handleSendEvaluate}>
          Send Evaluate
        </Button>
      );
    }
    if (
      data.result[0].userId === userId &&
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.InRevision
    ) {
      return (
        <>
          <Button className="btn btn-danger" onClick={handleSendEvaluate}>
            ReSend Evaluate
          </Button>
          <Button
            className="btn btn-warning"
            onClick={() => setEvaluateModal(!evaluateModal)}
          >
            Read The Description
          </Button>
        </>
      );
    } else if (
      userRole.includes(Roles.SuperVisor) &&
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.InEvaluation
    ) {
      return (
        <Button
          className="btn btn-success"
          onClick={() => setEvaluateModal(!evaluateModal)}
        >
          Evaluate
        </Button>
      );
    } else if (
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.Accept ||
      ((userRole.includes(Roles.SuperVisor) ||
        data.result[0].userId !== userId) &&
        data.result[0].courseEvaluteStatus === courseEvaluateEnum.Accept)
    ) {
      return (
        <Button className="btn btn-success" disabled>
          {t("Course Is Published")}
        </Button>
      );
    } else if (
      data.result[0].courseEvaluteStatus === courseEvaluateEnum.Cancel
    ) {
      return (
        <>
          <Button className="btn btn-danger" disabled>
            {t("Course is rejected")}
          </Button>
          <Button
            className="btn btn-warning"
            onClick={() => setEvaluateModal(!evaluateModal)}
          >
            Read The Description
          </Button>
        </>
      );
    } else {
      return (
        <Button className="btn btn-warning" disabled>
          Sended to evaluate
        </Button>
      );
    }
  };

  const handleAssignVideo = async (videoId, publicVideoId) => {
    setAssigningVideo(true);
    
    // Create the appropriate model structure for the assignment
    const bulkVideoAssignModel = {
      RowNumberForSection:selectedRowNumber,
      title: videoTitle,
      sectionId: currentSectionId,
      videoId: videoId
    };

    try {
      // Use the new mutation instead of updateVideoAsync
      await updateAssignVideoAsync(bulkVideoAssignModel).then((response) => {
        if (response.data && response.data.isSuccess) {
          toast.success("Video assigned successfully");
          setShowUnassignedModal(false);
          refetchUnassignedVideos(); // Refresh unassigned videos list
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
        } else {
          toast.error(response.data?.messages?.[0] || "Failed to assign video");
        }
      });
    } catch (error) {
      toast.error("Error assigning video");
      console.error(error);
    } finally {
      setAssigningVideo(false);
    }
  };

  const openUnassignedVideosModal = (sectionId) => {
    setCurrentSectionId(sectionId);
    setSearchQuery(""); // Reset search when opening modal
    setShowUnassignedModal(true);
    // Fetch videos immediately when modal opens
    fetchUnassignedVideos();
  };

  if (isContinueProocess) {
    return isContinueProocess ? (
      <div>
        <IsLoading text={"Please waiting your while processing"}></IsLoading>
      </div>
    ) : (
      ""
    );
  } else {
    return (
      <div>
        {}

        <Fragment>
          <Navbar onAuthData={handleAuthForRoles} />
          <PageTitle pageTitle={t("Instructor")} pageSub={"CourseDetail"} />
       
            <div
                hidden= {!chooseVideo}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "60%",
                margin: "0 auto",
              }}
            >
              <VideoRefContext.Provider value={videoRef} >
            
          <video
         
            className="w-100 rounded-2xl"
            loop
            autoPlay
            ref={videoRef}
            muted
            controls
            controlsList="nodownload"
          >
            <source
              type="video/mp4"
            />
          </video>
              </VideoRefContext.Provider>
              <button onClick={()=>closeVideo()}>Close Video</button>
            </div>
    

          {modal ? (
            <CustomModal
              props={modal}
              changeVideoObject={videoDetail}
              type={title}
              onData={handleFromChildData}
            />
          ) : (
            ""
          )}

          {evaluateModal ? (
            <EvaluateModal
              props={evaluateModal}
              status={data}
              onData={handleSendEvaluate}
            ></EvaluateModal>
          ) : (
            ""
          )}
          <div>
            <div className="row">
              <div className="col">
                <Button onClick={handleOpen}>{t("Create New Section")}</Button>

                {renderButton()}
              </div>
            </div>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  <div className="col">
                    <div className="row">
                      <Input
                        type="text"
                        placeholder="Section Name"
                        onChange={(e) =>
                          setSectionModel({
                            ...sectionModel,
                            sectionName: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="row">
                      <Input
                        type="text"
                        placeholder="Description"
                        onChange={(e) =>
                          setSectionModel({
                            ...sectionModel,
                            description: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  <Button onClick={createSection}>Save Section</Button>
                </Typography>
              </Box>
            </Modal>
          </div>

          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable-sections">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {sections.map((section, index) => (
                    <Draggable
                      key={section.sectionId}
                      draggableId={section.sectionId}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <Accordion>
                            <Accordion.Item
                              eventKey={section.sectionId}
                              key={section.sectionId}
                            >
                              <Accordion.Header
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <input
                                  defaultValue={section.sectionName}
                                  disabled={
                                    editingSectionId !== section.sectionId
                                  }
                                  onChange={(e) =>
                                    setSectionModel({
                                      ...sectionModel,
                                      sectionName: e.target.value,
                                    })
                                  }
                                />{" "}
                                -
                                <input
                                  defaultValue={section.description}
                                  onChange={(e) =>
                                    setSectionModel({
                                      ...sectionModel,
                                      description: e.target.value,
                                    })
                                  }
                                  disabled={
                                    editingSectionId !== section.sectionId
                                  }
                                />
                                <a
                                  onClick={() =>
                                    handleClickEdit(section.sectionId)
                                  }
                                  onMouseEnter={() => {
                                    setSectionModel({
                                      ...sectionModel,
                                      description: section.description,
                                      sectionName: section.sectionName,
                                    });
                                  }}
                                >
                                  <IoPencil />
                                </a>
                                {editingSectionId === section.sectionId && (
                                  <button
                                    className="btn btn-success"
                                    onClick={() => {
                                      handleUpdateSection(section.sectionId);
                                    }}
                                  >
                                    update
                                  </button>
                                )}
                                <button
                                  style={{ marginLeft: "auto" }}
                                  onClick={() =>
                                    removeItem(section.sectionId, "section")
                                  }
                                  className="btn btn-danger"
                                >
                                  {t("Remove Section")}
                                </button>
                                <button
                                  style={{ marginLeft: "auto" }}
                                  data-target={section.sectionId}
                                  onClick={() => openUnassignedVideosModal(section.sectionId)}
                                  className="btn btn-secondary"
                                >
                                  {t("Add Video")}
                                </button>
                              </Accordion.Header>

                              {section.videos.map((video, key) => (
                                <Accordion.Body key={key}>
                                  <div key={key}>
                                    <a>
                                      <strong>
                                        <a>
                                          <input
                                            ref={inputRef}
                                            disabled={
                                              selectedVideoId !== video.videoId
                                            }
                                            onChange={(e) =>
                                              setRowNumber(e.target.value)
                                            }
                                            defaultValue={
                                              video.rowNumberForSection
                                            }
                                          />
                                          <button
                                            id={video.videoId}
                                            className="btn btn-warning"
                                            onClick={() =>
                                              handleClickedVideo(video.videoId)
                                            }
                                          >
                                            {" "}
                                            {handleClickedUpdateRows &&
                                            selectedVideoId === video.videoId
                                              ? "İptal"
                                              : "Sıra Değiştir"}{" "}
                                          </button>{" "}
                                          ----- {video.title}
                                          {handleClickedUpdateRows &&
                                          selectedVideoId === video.videoId ? (
                                            <button
                                              className="btn btn-success"
                                              onClick={() =>
                                                handleUpdateVideo(video.videoId)
                                              }
                                            >
                                              Save Changes
                                            </button>
                                          ) : (
                                            ""
                                          )}
                                          <button
                                            className="btn border-t-indigo-800"
                                            onClick={() =>
                                              handleClickWatchingVideo(
                                                video.publicVideoId
                                              )
                                            }
                                          >
                                            Watching Video
                                          </button>
                                          <button
                                            className="btn btn-primary"
                                            onClick={() => {
                                              setVideoDetail({
                                                publicVideoId:
                                                  video.publicVideoId,
                                                sectionId: section.sectionId,
                                                rowNumber:
                                                  video.rowNumberForSection,
                                                videoName: video.title,
                                              });
                                              handleOpenCustomModal(
                                                "ChangeVideo"
                                              );
                                            }}
                                          >
                                            Change Video
                                          </button>
                                          <a
                                            onClick={() =>
                                              removeItem(
                                                video.publicVideoId,
                                                "video"
                                              )
                                            }
                                          >
                                            <CiCircleRemove color="red">
                                              Remove
                                            </CiCircleRemove>
                                          </a>
                                        </a>
                                      </strong>
                                      <hr />
                                      <div style={{ position: "relative" }}>
                                        <a>
                                          {video.materials.length > 0 ? (
                                            video.materials.map(
                                              (material, key) => (
                                                <a key={key}>
                                                  {material.name}
                                                  <button
                                                    className="btn btn-secondary"
                                                    onClick={() =>
                                                      clickDownloadFile(
                                                        material.fileUrl
                                                      )
                                                    }
                                                  >
                                                    download
                                                  </button>
                                                  <button
                                                    className="btn btn-danger"
                                                    onClick={() =>
                                                      handleRemoveFile(
                                                        material.fileUrl
                                                      )
                                                    }
                                                  >
                                                    remove
                                                  </button>
                                                </a>
                                              )
                                            )
                                          ) : (
                                            <button
                                              className="btn btn-warning"
                                              id="newMaterialButton"
                                              ref={buttonRef}
                                              data-value={video.videoId}
                                              onClick={() => {
                                                handleOpenCustomModal(
                                                  "NewMaterial"
                                                );
                                                setVideoId(video?.videoId);
                                              }}
                                            >
                                              Add Material
                                            </button>
                                          )}
                                        </a>
                                      </div>
                                    </a>
                                  </div>

                                  <br />
                                  <hr
                                    style={{
                                      backgroundColor: "red",
                                      height: "5px",
                                    }}
                                  />
                                </Accordion.Body>
                              ))}
                            </Accordion.Item>
                          </Accordion>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          <Modal
            open={showUnassignedModal}
            onClose={() => setShowUnassignedModal(false)}
            aria-labelledby="unassigned-videos-modal-title"
            aria-describedby="unassigned-videos-modal-description"
          >
            <Box sx={modalStyle}>
              <Typography 
                id="unassigned-videos-modal-title" 
                variant="h6" 
                component="h2" 
                sx={{ 
                  mb: 3,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  borderBottom: '1px solid #eee',
                  paddingBottom: '10px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {t("Unassigned Videos")}
                {/* Add refresh button */}
                <Button 
                  variant="text"
                  color="primary"
                  sx={{ ml: 2 }}
                  onClick={fetchUnassignedVideos}
                  disabled={isUnassignedVideosLoading || unassignedVideosLoading}
                >
                  <IoRefresh size={24} />
                </Button>
              </Typography>
              
              {(isUnassignedVideosLoading || unassignedVideosLoading) ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                  <Spinner />
                  <span style={{ marginLeft: '10px' }}>{t("Loading videos...")}</span>
                </div>
              ) : unassignedVideosError || isUnassignedVideosError ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <Typography variant="body1" color="error">
                    {t("Failed to load videos")}
                  </Typography>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={fetchUnassignedVideos}
                    sx={{ mt: 2 }}
                  >
                    {t("Try Again")}
                  </Button>
                </div>
              ) : unassignedVideosData && unassignedVideosData.length > 0 ? (
                <div>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    {t("Select a video to add to this section")}
                  </Typography>
                  
                  <div style={{ mb: 3 }}>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      {t("Row number for this video in section")}:
                    </Typography>
                    <Input 
                      type="number" 
                      defaultValue={1} 
                      min={1}
                      onChange={(e) => setSelectedRowNumber(parseInt(e.target.value) || 1)}
                      sx={{ mb: 3 }}
                    />
                  </div>
                  <div style={{ mb: 3 }}>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      {t("Video Title")}:
                    </Typography>
                    <Input 
                      type="text" 
                      defaultValue={"Title"} 
                      onChange={(e) => setVideoTitle(e.target.value) || ""}
                      sx={{ mb: 3 }}
                    />
                  </div>
                  {/* Add search input */}
                  <div style={{ marginBottom: '20px' }}>
                    <Input
                      type="text"
                      placeholder={t("Search videos...")}
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                      }}
                    />
                  </div>
                  
                  <div style={{ maxHeight: '400px', overflow: 'auto' }}>
                    {filteredUnassignedVideos.length > 0 ? (
                      filteredUnassignedVideos.map((video) => (
                        <div 
                          key={video.videoId} 
                          style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            padding: '12px',
                            marginBottom: '10px',
                            border: '1px solid #eee',
                            borderRadius: '8px',
                            backgroundColor: '#f9f9f9'
                          }}
                        >
                          <div>
                            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                              {video.title}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              ID: {video.publicVideoId}
                            </Typography>
                          </div>
                          <Button 
                            variant="contained"
                            color="primary"
                            onClick={() => handleAssignVideo(video.videoId, video.publicVideoId)}
                            disabled={assigningVideo}
                          >
                            {assigningVideo ? <Spinner size="sm" /> : t("Add to Section")}
                          </Button>
                        </div>
                      ))
                    ) : (
                      <div style={{ textAlign: 'center', padding: '20px' }}>
                        <Typography variant="body1">
                          {t("No videos found matching your search")}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <Typography variant="body1">
                    {t("No unassigned videos available")}
                  </Typography>
                </div>
              )}
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button 
                  onClick={() => {
                    setVideoDetail({
                      ...videoDetail,
                      sectionId: currentSectionId,  // Make sure to set the current section ID
                    });
                    handleOpenCustomModal("NewVideo");
                    setShowUnassignedModal(false);
                  }}
                  variant="outlined"
                >
                  {t("Upload New Video")}
                </Button>
                
                <Button 
                  onClick={() => setShowUnassignedModal(false)}
                  variant="contained"
                  color="secondary"
                >
                  {t("Close")}
                </Button>
              </Box>
            </Box>
          </Modal>

          <Footer />
          <Scrollbar />
        </Fragment>
      </div>
    );
  }
}

export default InstructorAuth(InstructorsCourseDetail);
